import { ref, computed, toValue } from 'vue';

export const useUnitAllocation = (players, max) => {
  const entered = ref({});

  const enteredSum = computed(() =>
    Object.values(entered.value).reduce((sum, units) => sum + units, 0)
  );

  const isEntered = (id) => id in entered.value;

  const autoId = computed(() => {
    const list = toValue(players);
    const untouched = list.filter((player) => !isEntered(player.id));
    return list.length > 1 && untouched.length === 1 ? untouched[0].id : null;
  });

  const counts = computed(() =>
    Object.fromEntries(
      toValue(players).map((player) => [
        player.id,
        player.id === autoId.value
          ? Math.max(0, toValue(max) - enteredSum.value)
          : (entered.value[player.id] ?? 0)
      ])
    )
  );

  const remaining = computed(
    () => toValue(max) - Object.values(counts.value).reduce((sum, units) => sum + units, 0)
  );

  const isComplete = computed(() => remaining.value === 0);

  const limitFor = (id) =>
    toValue(max) -
    toValue(players)
      .filter((player) => player.id !== id && player.id !== autoId.value)
      .reduce((sum, player) => sum + counts.value[player.id], 0);

  const set = (id, units) => {
    entered.value = { ...entered.value, [id]: Math.max(0, Math.min(units, limitFor(id))) };
  };

  const reset = () => {
    entered.value = {};
  };

  return { counts, remaining, isComplete, autoId, isEntered, limitFor, set, reset };
};
